import { I_CT_LOTTO_CONFIG } from '@/constants/types/ctLotto'
interface I_PICK_3 {
	TITLE_GAME: string
	SLUG_GAME: string
	LOCAL_STORAGE_KEY: string
	LOCAL_STORAGE_KEY_CART: string
	STEP_CART: number
	DEFAULT_NUMBER_PICKS: number
	DEFAULT_WAGER: number
	DEFAULT_LIST_NUMBER: number[]
	DEFAULT_MAX_PER_BALL: number
	URL_TYPE_API: string
	URL_PATH: string
	ROUTER_NAME: string
	URL_PATH_NUMBER: string
	ROUTER_NAME_NUMBER: string
}

interface I_PICK_3 {
	TITLE_GAME: string
	SLUG_GAME: string
	LOCAL_STORAGE_KEY: string
	LOCAL_STORAGE_KEY_CART: string
	STEP_CART: number
	DEFAULT_NUMBER_PICKS: number
	DEFAULT_WAGER: number
	DEFAULT_LIST_NUMBER: number[]
	DEFAULT_MAX_PER_BALL: number
	URL_TYPE_API: string
	URL_PATH: string
	ROUTER_NAME: string
	URL_PATH_NUMBER: string
	ROUTER_NAME_NUMBER: string
}

export const INSTANT_SLUG_API = 'instant-lotto'
export const INSTANT_SLUG_GAME = 'tac-tac'
export const INSTANT_GAME_TITLE = 'Tac Tac'
export const INSTANT_BALL_RENDER = 80
export const INSTANT_BALL_PICK = 10
export const INSTANT_BALL_MAX_PICK = 10
export const INSTANT_DRAWS = 1
export const INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE = 5
export const INSTANT_DETAIL_LIMIT_SHOW_NUMBER_LINE_RESULT = 10


const DEFAULT_WAGER_PICK_3 = process.env.VUE_APP_PICK_3_DEFAULT_WAGER
export const CT_PICK_3: I_PICK_3 = {
	TITLE_GAME: 'Lotto Pick 3',
	SLUG_GAME: 'pick-3-lotto-guinee',
	LOCAL_STORAGE_KEY: 'local__pick-3-lotto-guinee',
	LOCAL_STORAGE_KEY_CART: 'local__cart-pick-3-lotto-guinee',
	STEP_CART: 6,
	DEFAULT_NUMBER_PICKS: 3,
	DEFAULT_WAGER: DEFAULT_WAGER_PICK_3 ? parseInt(DEFAULT_WAGER_PICK_3) : 2000,
	DEFAULT_LIST_NUMBER: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
	DEFAULT_MAX_PER_BALL: -1,
	URL_TYPE_API: 'fixed-daily-lotto',
	URL_PATH: '/lotto-pick-3',
	ROUTER_NAME: 'Lotto Pick 3',
	URL_PATH_NUMBER: '/lotto-pick-3/numbers',
	ROUTER_NAME_NUMBER: 'Lotto Pick 3 numbers',
}

export const CT_LOTTO_545: I_CT_LOTTO_CONFIG = {
    SLUG: 'lotto-5-45',
    GAME_NAME: 'lotto 5 of 45',
    API_URL_TYPE: 'pari-mutuel-lotto',
    LOCAL_STORAGE_KEY_EVENTS: 'lotto545-event',
    NAME_OF_COMPONENT: 'lotto545Number',
    IS_COMBINATIONS: false,
    EVENT_CLASS_NAME: 'lotto545',
}

